export enum FEATURE_FLAGS {
  foamAdvancedFilters = 'foam_advanced_filters',
  foamAgencySettingsManagerRoleCanRemoveCreator = 'foam_agency_settings_manager_role_can_remove_creator',
  foamAiBrandKeywords = 'ai_brand_keywords',
  foamCampaign = 'foam_rfp_gmail',
  foamChromePushNotifications = 'foam_chrome_push_notifications',
  foamCreatorListingPage = 'foam_creator_listing_page',
  foamCreatorProfile = 'foam_creator_profile',
  foamDemoContentSearchAutocomplete = 'foam_demo_content_search_autocomplete',
  foamContentSearchPostedAtColumn = 'foam_content_search_posted_at_column',
  foamEmailAssistant = 'foam_email_assistant',
  foamHeapDev = 'foam_heap_dev',
  foamNotificationSettings = 'foam_notification_settings',
  foamOffPlatform = 'foam_off_platform',
  foamProfileSettings = 'foam_profile_settings',
  foamReels = 'foam_reels',
  foamReelsMediaPack = 'foam_reels_media_pack',
  foamRosterHideFilters = 'foam_roster_hide_filters',
  foamRosterTalentSearch = 'foam_roster_talent_search',
  foamSavedListAgencies = 'foam_saved_lists_agencies',
  foamSavedLists = 'foam_saved_lists',
  foamSavedListSave = 'foam_saved_list_save',
  foamStackedView = 'foam_stacked_view',
  foamTalentFilters = 'foam_talent_filters',
  foamOffPlatformAddSocials = 'foam_off_platform_add_socials',
  foamOffPlatformRemoveSocials = 'foam_off_platform_remove_socials',
  foamOffPlatformYoutube = 'foam_off_platform_youtube',
  foamSharedActivity = 'foam_shared_activity',
  foamMagicProfiles = 'foam_magic_profiles',
  snapchatAuth = 'foam_snapchat_authentication',
  foamSavedListsRoster = 'foam_saved_lists_roster',
  foamGlobalSearch = 'foam_global_search',
  foamGlobalSearchInWM = 'foam_global_search_in_WM',
  foamGlobalSearchFiltersInWM = 'foam_global_search_filters_in_wm',
  foamOffPlatformRosterImport = 'foam_off_platform_roster_import',
  foamSavedListsPin = 'foam_saved_lists_pin',
  foamCollapsedView = 'foam_collapsed_view',
  foamEmbedsAlignment = 'foam_embeds_alignment',
  foamWebLinks = 'foam_web_links',
  foamUnverifiedToVerified = 'foam_unverified_to_verified',
  foamManagerContactShared = 'foam_manager_contact_shared',
  foamMediaPackContentLinksUpdate = 'foam_media_pack_content_links_update',
  foamTalentRecordAudienceDemo = 'foam_talent_record_audience_demo',
  foamAddTalent = 'foam_add_talent',
  foamSmartCreatorProfiles = 'foam_smart_creator_profiles',
  foamSmartProfilesBulkImport = 'foam_smart_profiles_bulk_import',
  foamSharedTalentProfile = 'foam_shared_talent_profile',
  foamTalentEmptyState = 'foam_talent_empty_state',
  foamTalentLocation = 'foam_talent_location',
  foamFeatureFlagController = 'foam_feature_flag_controller',
  foamContentProfileLink = 'foam_content_profile_link',
  foamContentSearchEmptyState = 'foam_content_search_empty_state',
  foamWeeklyReportToggle = 'foam_weekly_report_toggle',
  foamSavedListsEmptyState = 'foam_saved_lists_empty_state',
  foamTestingFlag = 'foam_testing_flag',
  foamCustomShareable = 'foam_custom_shareable',
  foamMarketingBanner = 'foam_marketing_banner',
  foamTalentRecordChannelMetrics = 'foam_talent_record_channel_metrics',
  foamAgencySettingsBulkAssignPrimaryManager = 'foam_agency_settings_bulk_assign_primary_manager',
  foamMetricsCollaborations = 'foam_metrics_collaborations',
  foamProfileSharedPreviews = 'foam_profile_shared_previews',
  foamOnboardingNewManager = 'foam_onboarding_new_manager',
  foamNewFloatingActionBarInLists = 'foam_new_floating_action_bar_in_lists',
  foamNewFloatingActionBarInRoster = 'foam_new_floating_action_bar_in_roster',
  foamNewFloatingActionBarInAgencySettings = 'foam_new_floating_action_bar_in_agency_settings',
  foamAccessibleViewProfileBtn = 'foam_accessible_view_profile_btn',
  foamStreamingPoc = 'foam_streaming_poc',
  foamTalentGlobalFilters = 'foam_talent_global_filters',
  foamContentGlobalFilters = 'foam_content_global_filters',
  foamMediaKitsTextbox = 'foam_media_kits_textbox',
  foamMediaKitsVideo = 'foam_media_kits_video',
  foamMediaKitsContent = 'foam_media_kits_content',
  whalarModeTesting = 'whalar_mode_testing',
  globalSearchSubNavbar = 'foam_global_search_sub_navbar',
  foamInviteOnPlatformUnmanaged = 'foam_invite_on_platform_unmanaged',
  foamInviteOnPlatformManaged = 'foam_invite_on_platform_managed',
  foamInviteTalentFromAddFlow = 'foam_invite_talent_from_add_flow',
  wmAddToListWithNotes = 'wm_add_to_list_with_notes',
  foamSmartTalentMetrics = 'foam_smart_talent_metrics',
  foamSnapchatAnalytics = 'foam_snapchat_analytics',
  foamMediaKitsTalentProfileTab = 'foam_media_kits__talent_profile_tab',
  foamDeprecateMediaPacks = 'foam_deprecate_media_packs',
  foamAddTalentFromList = 'foam_add_talent_from_list',
  wmListNotesLineJump = 'wm_list_notes_line_jump',
  foamListDetailEditName = 'foam_list_detail_edit_name',
  foamGlobalSearchInputDropdown = 'foam_global_search_input_dropdown',
  wmRedirectOldSharedLists = 'wm_redirect_old_shared_lists',
  foamMediaKitsTheme = 'foam_media_kits_theme',
  foamMediaKitsMadeWithFoam = 'foam_media_kits_made_with_foam',
  foamMediaKitsShareToLinkedIn = 'foam_media_kits_share_to_linkedin',
  foamGlobalSearchQuickResults = 'foam_global_search_quick_results',
  foamMediaKitsStyleBtn = 'foam_media_kits_style_btn',
  foamGlobalSearchSuggestions = 'foam_global_search_suggestions',
  foamFontOverrideComicSans = 'foam_font_override_comic_sans',
}
